import React, { useContext } from "react"
import "./StatCohorte.css"
import { UsuarioContext } from "../Context/Usuario"
import UAI from "../UAI"

/**
 * StatCohorte es un componente que muestra una estadística con el formato adecuado
 * dependiendo de qué dato es el que está mostrando. Por ejemplo usar símbolo $ para
 * cuando son ventas o bien decimales cuando son alumnos equivalentes.
 * @param {*} props
 */
const StatCohorte = (props) => {
  const { usuario } = useContext(UsuarioContext)

  let delta = 0
  let deltamobile = 0
  let css = ""
  if (
    props.stat &&
    props.statprev &&
    props.name &&
    props.stat[props.name] !== undefined &&
    props.statprev[props.name] !== undefined
  ) {
    delta = props.stat[props.name] - props.statprev[props.name]
    deltamobile = props.stat[props.name] - props.statprev[props.name]
    css = delta > 0 ? "text-success" : delta < 0 ? "text-danger" : ""
    if (delta !== 0) {
      let original = delta
      if (props.name === "Equivalentes") {
        delta = Math.round((delta + Number.EPSILON) * 10) / 10
        deltamobile = delta
      }
      if (props.name.slice(0, 5) === "Venta" || props.Porcentaje) {
        delta =
          props.statprev[props.name] > 0
            ? (delta / props.statprev[props.name]) * 100
            : 100
        if (props.SinDecimales) {
          delta = Math.round((delta + Number.EPSILON) * 1) / 1
        } else {
          delta = Math.round((delta + Number.EPSILON) * 10) / 10
        }
        if (delta === 0) {
          css = css + " d-none"
        }
        css = css + " delta-ventas"
        delta = delta + "%"
        deltamobile = delta
      }
      if (original > 0) {
        delta = "+" + delta
        deltamobile = "+" + deltamobile
      }
    }
  }
  let value = 0
  let valuemobile = 0
  let cssblock = ""
  if (props.stat && props.name && props.stat[props.name] !== undefined) {
    value = props.stat[props.name]
    valuemobile = props.stat[props.name]
    if (props.name.slice(0, 5) === "Venta") {
      let options = {
        style: "currency",
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
        currency: "CLP",
      }
      value = Math.round(value / 1000000)
      valuemobile = Math.round(value / 1000000)
      value = value.toLocaleString("es-CL", options)
      valuemobile = valuemobile.toLocaleString("es-CL", options)
    }
    if (props.name === "Equivalentes") {
      value = Math.round((value + Number.EPSILON) * 10) / 10
      valuemobile = value
    }
    if (props.name.includes("Cumplimiento")) {
      value = value + "%"
      valuemobile = value
    }
    if (props.name.includes("Meta")) {
      value = Math.round((value + Number.EPSILON) * 10) / 10
      valuemobile = value
    }
    if (props.name === "MetasMensuales") {
      let mes = new Date(Date.now()).getMonth()
      let metaMes = props.stat.MetasMensuales.find((m) => {
        return m.Mes === UAI.meses[mes]
      })
      value = metaMes ? metaMes.Equivalentes.toFixed(1) : ""
      valuemobile = value
    }
    if (props.name === "Interesados" || props.name === "Visitantes") {
      let options = {
        style: "decimal",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
        currency: "CLP",
      }
      value = value.toLocaleString("es-CL", options)
    }
    cssblock =
      " " +
      (new Date(Date.parse(props.stat.Fecha)).getFullYear() === usuario.periodo)
        ? " current"
        : " previous"
  }
  if (props.versus && props.stat[props.versus]) {
    value = value + "/" + props.stat[props.versus]
  }
  return (
    <div
      className={
        props.name.toLowerCase() + (props.Periodo ? " stat-periodo" : "")
      }
      title={props.title ? props.title : undefined}
    >
      <div className={"statblock" + cssblock}>
        <div className="stat">
          <span className="d-none d-sm-block">{value}</span>
          <span className="d-sm-none">{valuemobile}</span>
          {delta !== 0 && (
            <div className={"delta " + css}>
              <span className="d-none d-sm-block">{delta}</span>
              <span className="d-sm-none">{deltamobile}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default StatCohorte
